export function initScorm12Api({
    initialState,
    onCommit,
    onComplete
}: {
    initialState?: {
        lesson_location?: string
        lesson_status?: string
        total_time?: number
        data?: Record<string, string>
    }
    onCommit?: (payload: {
        lesson_status: string
        lesson_location: string
        total_time: number
        data: Record<string, string>
    }) => void
    onComplete?: () => void
}) {
    let lessonStatus = initialState?.lesson_status ?? 'not attempted'
    let lessonLocation = initialState?.lesson_location ?? ''
    let totalTime = initialState?.total_time ?? 0 // seconds
    let sessionStart = Date.now()

    // Persist ONLY real cmi.* data
    let data: Record<string, string> = initialState?.data ?? {}
    let dirty = false

    const API = {
        LMSInitialize: () => {
            sessionStart = Date.now()
            return 'true'
        },

        LMSFinish: () => {
            commit(true)

            if (lessonStatus === 'completed' || lessonStatus === 'passed') {
                onComplete?.()
            }

            return 'true'
        },

        LMSGetValue: (key: string) => {
            console.log(`[SCORM 1.2] LMSGetValue called with key=${key}`)
            switch (key) {
                case 'cmi.core.lesson_status':
                    return lessonStatus
                case 'cmi.core.lesson_location':
                    return lessonLocation
                case 'cmi.core.total_time':
                    return formatTime(totalTime)
                default:
                    return data[key] ?? ''
            }
        },

        LMSSetValue: (key: string, value: string) => {
            console.log(`[SCORM 1.2] LMSSetValue called with key=${key}, value=${value}`)
            // LMS-owned fields
            if (key === 'cmi.core.lesson_status') {
                lessonStatus = value
                dirty = true
                return 'true'
            }

            if (key === 'cmi.core.lesson_location') {
                lessonLocation = value
                dirty = true
                return 'true'
            }

            // Ignore read-only fields
            if (key === 'cmi.core.total_time') {
                return 'false'
            }

            // Store everything else (suspend_data, interactions, objectives, etc.)
            data[key] = value
            dirty = true
            commit(false)
            return 'true'
        },

        LMSCommit: () => {
            commit(false)
            return 'true'
        },

        LMSGetLastError: () => '0',
        LMSGetErrorString: () => '',
        LMSGetDiagnostic: () => ''
    }

    function commit(isFinal: boolean) {
        const sessionSeconds = Math.floor((Date.now() - sessionStart) / 1000)
        totalTime += sessionSeconds
        sessionStart = Date.now()

        if (!dirty && !isFinal) return

        onCommit?.({
            lesson_status: lessonStatus,
            lesson_location: lessonLocation,
            total_time: totalTime,
            data
        })

        dirty = false
    }

    window.addEventListener('beforeunload', () => commit(true))

        ; (window as any).API = API
        ; (window as any).parent.API = API
        ; (window as any).top.API = API
}


function formatTime(seconds: number) {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60
    return `${pad(h)}:${pad(m)}:${pad(s)}`
}

function pad(n: number) {
    return n.toString().padStart(2, '0')
}
